'use client'
import {
  CollapsableText_default
} from "./chunk-MAJWJHOB.mjs";
import {
  ContentfulRichText_default
} from "./chunk-DR2RGIIC.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";
import {
  createSectionItemHref
} from "./chunk-DJNQ4XY4.mjs";
import {
  useGetZones
} from "./chunk-AUFMP3KM.mjs";
import {
  __async
} from "./chunk-UYSR6ZT4.mjs";

// src/components/zone/Breadcrumb.tsx
import { Button } from "@wbk/ui";
import { ChevronIcon } from "@wbk/svg";
import { Link, useRouter, useTranslation } from "@wbk/config";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ZoneBreadcrumb = ({ zone, ignoreSeason = false }) => {
  const { locale } = useRouter();
  const { t } = useTranslation("contentful_zone");
  return /* @__PURE__ */ jsxs("ul", { className: "flex flex-wrap items-center gap-2 truncate p-px text-sm", children: [
    /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
      Button,
      {
        as: Link,
        theme: "action",
        shape: "text",
        href: `/${locale}`,
        className: "px-1 py-0 underline",
        children: t("contentful_zone:home")
      }
    ) }),
    /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(ChevronIcon, { className: "text-text-secondary mt-0.5 h-3 w-3" }) }),
    (zone == null ? void 0 : zone.season) && !ignoreSeason && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        Button,
        {
          as: Link,
          theme: "action",
          shape: "text",
          href: `/${locale}/season/${zone.season.slug}`,
          className: "px-1 py-0 underline",
          children: zone.season.title
        }
      ) }),
      /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(ChevronIcon, { className: "text-text-secondary mt-0.5 h-3 w-3" }) })
    ] }),
    /* @__PURE__ */ jsx("li", { className: "text-text-secondary", children: /* @__PURE__ */ jsx("span", { children: zone.title }) })
  ] });
};
var Breadcrumb_default = ZoneBreadcrumb;

// src/components/zone/Hero.tsx
import { useEffect as useEffect2 } from "react";
import { Button as Button4, Carousel, ShareModal, Typography as Typography2 } from "@wbk/ui";
import { QueueView, useQueue as useQueue2 } from "@wbk/queue";
import { scrollIntoElementId } from "@wbk/utils";
import { Link as Link3, useRouter as useRouter3, useTranslation as useTranslation4 } from "@wbk/config";
import { ChevronIcon as ChevronIcon2, UploadIcon } from "@wbk/svg";
import { useAnalytics as useAnalytics2 } from "@wbk/analytics";

// src/components/events/buttons/FavoriteButton.tsx
import { useEffect, useRef, useState } from "react";
import { Link as Link2, Trans, useRouter as useRouter2, useTranslation as useTranslation2 } from "@wbk/config";
import { AuthModal, useAuth } from "@wbk/auth";
import { Button as Button2, Toast, Typography } from "@wbk/ui";
import { Heart } from "@wbk/svg";
import { useAnalytics } from "@wbk/analytics";
import { useGetFavoriteEvent, useToggleUserFavorite } from "@wbk/api/hooks";
import { readCookie } from "@wbk/utils";
import { useQueue } from "@wbk/queue";
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var FavoriteButton = ({ event, hideLabel = false, shape = "large" }) => {
  const [isFavorite, setIsFavorite] = useState(false);
  const { t } = useTranslation2("contentful_common");
  const { locale } = useRouter2();
  const { trackEvent } = useAnalytics();
  const debounceRef = useRef(void 0);
  const errorToast = useRef(void 0);
  const toggleToast = useRef(void 0);
  const { isActive } = useQueue();
  const { user } = useAuth();
  const { data: favorite } = useGetFavoriteEvent(
    { slug: event.slug },
    { enabled: !!user && !isActive }
  );
  const { mutateAsync: toggleUserFavorite } = useToggleUserFavorite();
  useEffect(() => {
    setIsFavorite(!!(favorite == null ? void 0 : favorite._id));
  }, [favorite]);
  const handleToggleWishlist = () => {
    var _a;
    const newState = !isFavorite;
    setIsFavorite(newState);
    trackEvent({
      event: newState ? "item_favorited" : "item_unfavorited",
      data: newState ? {
        item_slug: event.slug,
        item_category: (_a = event.category) == null ? void 0 : _a.title
      } : {
        item_slug: event.slug
      }
    });
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => __async(null, null, function* () {
      var _a2, _b;
      if (isFavorite && !(favorite == null ? void 0 : favorite._id) || !isFavorite && (favorite == null ? void 0 : favorite.status) === "create") return;
      try {
        yield toggleUserFavorite({
          slug: event.slug,
          type: event.__typename,
          entry_id: event.sys.id,
          _id: isFavorite ? favorite == null ? void 0 : favorite._id : void 0
        });
        (_a2 = toggleToast.current) == null ? void 0 : _a2.publish(() => ({
          title: /* @__PURE__ */ jsx2(Typography, { color: "text-tertiary", children: /* @__PURE__ */ jsx2(
            Trans,
            {
              ns: "contentful_common",
              i18nKey: `${isFavorite ? "event_removed_from_wishlist" : "event_added_to_wishlist"}`,
              values: {
                event: event.title
              },
              children: /* @__PURE__ */ jsx2(
                Button2,
                {
                  className: "text-text-tertiary p-0 underline underline-offset-2",
                  theme: "action",
                  shape: "text",
                  as: Link2,
                  to: `/${locale}/profile/favorites`
                }
              )
            }
          ) }),
          type: "info",
          dismissible: false
        }));
      } catch (error) {
        (_b = errorToast.current) == null ? void 0 : _b.publish(() => ({
          title: t(
            `contentful_common:${isFavorite ? "failed_to_remove_from_wishlist" : "failed_to_add_to_wishlist"}`
          ),
          type: "error"
        }));
      }
    }), 1e3);
  };
  return /* @__PURE__ */ jsxs2(Fragment2, { children: [
    /* @__PURE__ */ jsx2(Toast, { ref: errorToast }),
    /* @__PURE__ */ jsx2(Toast, { ref: toggleToast, className: "bg-body-dark" }),
    /* @__PURE__ */ jsx2(
      AuthModal,
      {
        onSuccess: () => {
          handleToggleWishlist();
        },
        render: ({ open }) => /* @__PURE__ */ jsxs2(
          Button2,
          {
            theme: shape === "small" ? "transparent" : "action",
            shape: shape === "small" ? "text" : "outlined",
            className: shape === "small" ? "bg-body/20 hover:bg-body/10 h-10 w-10 rounded-full p-0" : "",
            onClick: () => {
              if (readCookie("token")) {
                return handleToggleWishlist();
              }
              return open();
            },
            children: [
              /* @__PURE__ */ jsx2(
                Heart,
                {
                  "data-favorite": isFavorite,
                  className: "data-[favorite=true]:text-primary data-[favorite=true]:stroke-primary stroke-body-dark h-5 w-5 shrink-0 text-transparent transition-all"
                }
              ),
              hideLabel || shape === "small" ? null : t("contentful_common:save")
            ]
          }
        )
      }
    )
  ] });
};
var FavoriteButton_default = FavoriteButton;

// src/components/zone/Info.tsx
import { twMerge } from "tailwind-merge";
import { LocationIcon } from "@wbk/svg";
import { Button as Button3 } from "@wbk/ui";
import { useTranslation as useTranslation3 } from "@wbk/config";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var googlePlaceNameBaseUrl = "https://maps.app.goo.gl";
var googleLatLngBaseUrl = "https://www.google.com/maps/search/?api=1&query=";
var ZoneInfoSection = ({ zone, className }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { t } = useTranslation3("contentful_zone");
  const location = zone.location;
  const address = location == null ? void 0 : location.address;
  const hasInfoItems = !!((_b = (_a = zone.infoListCollection) == null ? void 0 : _a.items) == null ? void 0 : _b.length);
  if (!location || !hasInfoItems) {
    return null;
  }
  const locationLink = (location == null ? void 0 : location.googlePlaceName) ? `${googlePlaceNameBaseUrl}/${location == null ? void 0 : location.googlePlaceName}` : ((_c = location == null ? void 0 : location.location) == null ? void 0 : _c.lat) && ((_d = location == null ? void 0 : location.location) == null ? void 0 : _d.lon) ? `${googleLatLngBaseUrl}${(_e = location == null ? void 0 : location.location) == null ? void 0 : _e.lat},${(_f = location == null ? void 0 : location.location) == null ? void 0 : _f.lon}` : void 0;
  return /* @__PURE__ */ jsx3("section", { className: twMerge("container py-6 text-center", className), children: /* @__PURE__ */ jsxs3("ul", { className: "border-paper flex w-full flex-col flex-wrap justify-between gap-6 rounded-xl border p-4 sm:flex-row md:gap-10", children: [
    (_h = (_g = zone.infoListCollection) == null ? void 0 : _g.items) == null ? void 0 : _h.map((item, i) => /* @__PURE__ */ jsxs3("li", { className: "flex items-start gap-4", children: [
      item.icon && /* @__PURE__ */ jsx3(ContentfulMedia_default, { media: item.icon, className: "h-8 w-8", format: null }),
      /* @__PURE__ */ jsxs3("div", { className: "text-start", children: [
        /* @__PURE__ */ jsx3("p", { className: "font-semibold", children: item.title }),
        item.description && /* @__PURE__ */ jsx3("div", { className: "text-text-secondary", children: /* @__PURE__ */ jsx3(ContentfulRichText_default, { description: item.description }) })
      ] })
    ] }, i)),
    address && /* @__PURE__ */ jsxs3("li", { className: "flex items-start gap-4", children: [
      /* @__PURE__ */ jsx3(LocationIcon, { className: "h-8 w-8" }),
      /* @__PURE__ */ jsxs3("div", { className: "text-start", children: [
        /* @__PURE__ */ jsx3("p", { className: "font-semibold", children: (location == null ? void 0 : location.seactionHeader) || t("contentful_zone:location") }),
        locationLink ? /* @__PURE__ */ jsx3(
          Button3,
          {
            as: "a",
            target: "_blank",
            rel: "noreferrer",
            href: locationLink,
            className: "px-px py-0 text-start underline",
            theme: "white",
            shape: "text",
            children: address
          }
        ) : /* @__PURE__ */ jsx3("p", { className: "text-text-secondary", children: address })
      ] })
    ] })
  ] }) });
};
var Info_default = ZoneInfoSection;

// src/components/zone/Hero.tsx
import { Fragment as Fragment3, jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var ZoneHeroSection = ({ zone, hideFavBtn = false, firstSectionId }) => {
  var _a, _b, _c, _d;
  const { locale } = useRouter3();
  const { t } = useTranslation4("contentful_zone");
  const { isActive, queue, initQueue } = useQueue2();
  const { generateLeadEvent } = useAnalytics2();
  const isExternalLink = (_b = (_a = zone.button) == null ? void 0 : _a.link) == null ? void 0 : _b.startsWith("http");
  useEffect2(() => {
    if (zone.button && !isExternalLink) {
      initQueue();
    }
  }, [initQueue, isExternalLink, zone.button]);
  return /* @__PURE__ */ jsxs4(Fragment3, { children: [
    /* @__PURE__ */ jsxs4("section", { className: "space-y-12 py-12", children: [
      /* @__PURE__ */ jsxs4("div", { className: "container flex flex-col-reverse items-start gap-6 md:flex-row md:justify-between md:gap-4", children: [
        /* @__PURE__ */ jsxs4("div", { className: "flex flex-col items-start gap-4 md:flex-row", children: [
          /* @__PURE__ */ jsxs4("div", { className: "shrink-0 space-y-2", children: [
            (zone == null ? void 0 : zone.zoneLogo) && /* @__PURE__ */ jsx4(
              ContentfulMedia_default,
              {
                className: "max-w-24 shrink-0",
                media: zone.zoneLogo,
                width: 250,
                height: "250"
              }
            ),
            (zone == null ? void 0 : zone.sponsorLogo) && /* @__PURE__ */ jsxs4("div", { className: "space-y-1 text-center", children: [
              /* @__PURE__ */ jsx4("p", { className: "text-text-secondary text-xs", children: t("contentful_zone:presented_by") }),
              /* @__PURE__ */ jsx4(
                ContentfulMedia_default,
                {
                  className: "mx-auto max-h-6 w-auto shrink-0",
                  media: zone == null ? void 0 : zone.sponsorLogo,
                  fit: "crop"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxs4("div", { className: "space-y-4", children: [
            /* @__PURE__ */ jsxs4("div", { className: "space-y-2", children: [
              /* @__PURE__ */ jsx4("h1", { className: "line-clamp-2", children: zone.title }),
              /* @__PURE__ */ jsx4("p", { className: "text-text-secondary line-clamp-4", children: zone.description })
            ] }),
            /* @__PURE__ */ jsxs4("div", { className: "flex max-w-sm flex-col gap-4 md:max-w-none md:flex-row", children: [
              zone.button && /* @__PURE__ */ jsxs4(
                Button4,
                {
                  as: Link3,
                  href: isExternalLink ? zone.button.link : `/${locale}${createSectionItemHref(zone)}/book`,
                  className: "buy-entry-ticket h-11 gap-2 py-3 leading-none",
                  "data-zone-name": zone.title,
                  disabled: isActive && !isExternalLink,
                  "data-category": "zone",
                  "data-testid": "zone_entry_button",
                  onClick: () => {
                    generateLeadEvent({
                      event_start_price: zone.startingPrice,
                      currency: "SAR",
                      title: zone.title,
                      slug: zone.slug
                    });
                  },
                  children: [
                    /* @__PURE__ */ jsx4(Typography2, { strong: true, children: isActive ? t("contentful_zone:queue_position", {
                      number: (queue == null ? void 0 : queue.waiting_number) || 1
                    }) : zone.button.label }),
                    !isActive && /* @__PURE__ */ jsx4(ChevronIcon2, { className: "shrink-0 rtl:rotate-180" })
                  ]
                }
              ),
              ((_c = zone.booklet) == null ? void 0 : _c.link) && /* @__PURE__ */ jsx4(
                Button4,
                {
                  theme: "white",
                  shape: "outlined",
                  className: "h-11 gap-2 py-3 font-semibold leading-none",
                  as: "a",
                  href: zone.booklet.link,
                  target: "_blank",
                  children: zone.booklet.text
                }
              ),
              firstSectionId && /* @__PURE__ */ jsx4(
                Button4,
                {
                  onClick: () => scrollIntoElementId(firstSectionId),
                  shape: "outlined",
                  theme: "white",
                  className: "h-11 gap-2 py-3 font-semibold leading-none",
                  children: t("contentful_zone:view_experiences")
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs4("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ jsx4(
            ShareModal,
            {
              icon: /* @__PURE__ */ jsx4(UploadIcon, { className: "h-5 w-5 shrink-0" }),
              data: {
                title: zone == null ? void 0 : zone.title,
                text: zone == null ? void 0 : zone.title
              },
              poster: (_d = zone.zoneLogo) == null ? void 0 : _d.url
            }
          ),
          !hideFavBtn && /* @__PURE__ */ jsx4(
            FavoriteButton_default,
            {
              event: {
                __typename: zone.__typename,
                id: zone.id,
                slug: zone.slug,
                title: zone.title,
                sys: zone.sys,
                category: zone.category
              }
            }
          )
        ] })
      ] }),
      isActive && /* @__PURE__ */ jsx4("div", { className: "container", children: /* @__PURE__ */ jsx4(QueueView, {}) }),
      zone.carousalCollection.items.length > 0 && /* @__PURE__ */ jsx4(
        Carousel,
        {
          options: {
            loop: zone.carousalCollection.items.length > 4,
            dragFree: true,
            duration: 4e4
          },
          autoplay: zone.carousalCollection.items.length > 4 ? { delay: 0 } : false,
          children: zone.carousalCollection.items.map((item) => /* @__PURE__ */ jsx4(
            ContentfulMedia_default,
            {
              media: item,
              className: "aspect-[3/2] shrink-0 basis-[75%] overflow-hidden rounded-md object-cover sm:basis-[60%] md:basis-[50%] lg:basis-[40%] xl:basis-[30%] ltr:mr-2 rtl:ml-2",
              placeholder: true,
              ratio: "3x1"
            },
            item.sys.id
          ))
        }
      )
    ] }),
    /* @__PURE__ */ jsx4(Info_default, { zone })
  ] });
};
var Hero_default = ZoneHeroSection;

// src/components/zone/HeroRS.tsx
import { ArrowIcon, ClockIcon, LocationIcon as LocationIcon2 } from "@wbk/svg";
import { Button as Button5, Carousel as Carousel2, Divider } from "@wbk/ui";
import { formatDate, scrollIntoElementId as scrollIntoElementId2 } from "@wbk/utils";
import { useRouter as useRouter4, useTranslation as useTranslation5 } from "@wbk/config";
import { Fragment as Fragment4, jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var HeroSectionRS = ({ zone }) => {
  var _a, _b;
  const { locale } = useRouter4();
  const { t } = useTranslation5("contentful_zone");
  if (!zone) return null;
  return /* @__PURE__ */ jsxs5(Fragment4, { children: [
    /* @__PURE__ */ jsx5("section", { children: /* @__PURE__ */ jsxs5("div", { className: "from-body/60 to-body relative flex min-h-screen flex-col justify-between from-10% via-transparent via-20% before:absolute before:inset-0 before:-z-10 before:bg-gradient-to-b", children: [
      zone.featuredBanner && /* @__PURE__ */ jsx5(
        ContentfulMedia_default,
        {
          media: zone.featuredBanner,
          className: "absolute -z-20 h-full w-full object-cover",
          autoPlay: true,
          muted: true,
          loop: true,
          playsInline: true
        }
      ),
      /* @__PURE__ */ jsxs5("div", { className: "container flex min-h-screen flex-col items-start justify-end gap-10 pb-20 lg:flex-row lg:items-end lg:justify-between", children: [
        /* @__PURE__ */ jsxs5("div", { className: "w-full max-w-3xl space-y-2 pt-32 sm:pt-0", children: [
          zone.zoneLogo && /* @__PURE__ */ jsxs5("div", { className: "divide-paper flex items-center gap-4 divide-x rtl:divide-x-reverse", children: [
            /* @__PURE__ */ jsx5(
              ContentfulMedia_default,
              {
                media: zone.zoneLogo,
                width: 100,
                height: 100,
                className: "shrink-0 object-contain pb-2"
              }
            ),
            (zone == null ? void 0 : zone.sponsorLogo) && /* @__PURE__ */ jsxs5("div", { className: "space-y-1 px-4 py-2", children: [
              /* @__PURE__ */ jsxs5("p", { className: "text-xs", children: [
                t("contentful_zone:presented_by"),
                ":"
              ] }),
              /* @__PURE__ */ jsx5(ContentfulMedia_default, { media: zone.sponsorLogo })
            ] })
          ] }),
          /* @__PURE__ */ jsx5("h1", { className: "text-4xl lg:text-7xl", children: zone.title }),
          zone.subtitle && /* @__PURE__ */ jsx5("p", { className: "text-lg font-semibold lg:text-xl", children: zone.subtitle }),
          zone.description && /* @__PURE__ */ jsx5(CollapsableText_default, { text: zone.description, markdown: true, className: "text-sm" })
        ] }),
        /* @__PURE__ */ jsxs5(
          Button5,
          {
            className: "mx-auto w-full max-w-xs gap-4 px-8 lg:mx-0 lg:w-auto",
            theme: "action",
            shape: "outlined",
            onClick: () => {
              scrollIntoElementId2("zone-details");
            },
            phill: true,
            children: [
              t("contentful_zone:explore"),
              /* @__PURE__ */ jsx5(ArrowIcon, { className: "h-5 w-5 -rotate-90" })
            ]
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs5("section", { className: "container flex flex-col gap-4 py-12 xl:flex-row", id: "zone-details", children: [
      /* @__PURE__ */ jsxs5("div", { className: "flex grow flex-col gap-4 sm:flex-row xl:h-[225px]", children: [
        !!zone.location && /* @__PURE__ */ jsxs5("div", { className: "relative flex h-full min-h-[225px] w-full flex-col justify-between overflow-hidden rounded-md", children: [
          zone.location.title && /* @__PURE__ */ jsx5("p", { className: "p-4 font-bold", children: zone.location.title }),
          /* @__PURE__ */ jsx5(
            ContentfulMedia_default,
            {
              className: "absolute -z-10 h-full w-full object-cover",
              media: zone.location.banner
            }
          ),
          /* @__PURE__ */ jsxs5("div", { className: "flex flex-col justify-between gap-4 p-4 md:flex-row md:items-center", children: [
            zone.location.address && /* @__PURE__ */ jsx5("p", { className: "text-sm", children: zone.location.address }),
            /* @__PURE__ */ jsxs5(
              Button5,
              {
                as: "a",
                target: "_blank",
                rel: "noreferrer",
                href: `https://www.google.com/maps/search/?api=1&query=${zone.location.location.lat},${zone.location.location.lon}`,
                className: "bg-body-dark/10 shrink-0 text-sm",
                theme: "white",
                shape: "text",
                children: [
                  /* @__PURE__ */ jsx5(LocationIcon2, { width: 15, height: 16 }),
                  t("contentful_zone:get_directions")
                ]
              }
            )
          ] })
        ] }),
        !!zone.schedule && /* @__PURE__ */ jsxs5("div", { className: "bg-body-level-1 min-w-[200px] grow space-y-3 rounded-md p-5", children: [
          /* @__PURE__ */ jsx5(ClockIcon, { width: 45, height: 45 }),
          zone.schedule.openScheduleText ? /* @__PURE__ */ jsx5("p", { className: "text-xl font-semibold xl:pt-4", children: zone.schedule.openScheduleText }) : /* @__PURE__ */ jsxs5(Fragment4, { children: [
            /* @__PURE__ */ jsx5("p", { className: "font-semibold", children: zone.schedule.openTitle }),
            /* @__PURE__ */ jsx5("p", { className: "text-sm", children: t("contentful_zone:time_from_to", {
              from: formatDate(zone.schedule.openDateTime, `${locale}-GB`, {
                timeStyle: "short"
              }),
              to: formatDate(zone.schedule.closeDateTime, `${locale}-GB`, {
                timeStyle: "short"
              })
            }) }),
            /* @__PURE__ */ jsx5(Divider, {}),
            /* @__PURE__ */ jsx5("p", { className: "text-sm", children: t("contentful_zone:date_between", {
              from: formatDate(zone.schedule.openDateTime, `${locale}-GB`, {
                day: "2-digit",
                month: "long"
              }),
              to: formatDate(zone.schedule.closeDateTime, `${locale}-GB`, {
                day: "2-digit",
                month: "long"
              })
            }) })
          ] })
        ] })
      ] }),
      ((_b = (_a = zone.carousalCollection) == null ? void 0 : _a.items) == null ? void 0 : _b.length) && /* @__PURE__ */ jsx5(
        Carousel2,
        {
          options: { loop: true },
          arrows: "middle",
          rootClassName: "h-full grow max-w-xl mx-auto xl:max-w-lg aspect-[3/2] overflow-hidden rounded-lg",
          dots: true,
          children: zone.carousalCollection.items.map((slide, i) => /* @__PURE__ */ jsx5(
            ContentfulMedia_default,
            {
              className: "relative aspect-[3/2] h-full w-full shrink-0 basis-full object-cover",
              media: slide
            },
            i
          ))
        }
      )
    ] }),
    zone.terms && /* @__PURE__ */ jsxs5("section", { className: "container space-y-4 py-12", children: [
      /* @__PURE__ */ jsx5("h2", { children: t("contentful_zone:terms_and_conditions") }),
      /* @__PURE__ */ jsx5(CollapsableText_default, { text: zone.terms })
    ] })
  ] });
};
var HeroRS_default = HeroSectionRS;

// src/components/zone/OtherZonesCarousel.tsx
import { useRouter as useRouter6, useTranslation as useTranslation7 } from "@wbk/config";

// src/components/zone/ZoneCarousel.tsx
import { formatDate as formatDate2 } from "@wbk/utils";
import { Button as Button6, Carousel as Carousel3, Typography as Typography3 } from "@wbk/ui";
import { Link as Link4, useRouter as useRouter5, useTranslation as useTranslation6 } from "@wbk/config";
import { useAnalytics as useAnalytics3 } from "@wbk/analytics";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var ZoneCarousel = ({ section }) => {
  const zones = section.contentCollection.items;
  const { locale } = useRouter5();
  const { t } = useTranslation6("contentful_zone");
  const { trackEvent } = useAnalytics3();
  if (!zones.length) return null;
  const formattedEndDate = (date) => {
    const month = formatDate2(new Date(date), locale, { month: "short" }).toUpperCase();
    const day = formatDate2(new Date(date), locale, { day: "numeric" });
    return `${day} ${month}`;
  };
  return /* @__PURE__ */ jsx6(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_cards_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx6(
        Carousel3,
        {
          className: "p-1",
          options: { dragFree: true },
          title: (section == null ? void 0 : section.title) ? /* @__PURE__ */ jsx6(Typography3, { as: "h2", variant: "heading-L", children: section.title }) : null,
          arrows: "top",
          children: zones.map((zone, i) => {
            var _a, _b;
            if (!zone) return null;
            const hasEnded = !!((_a = zone.schedule) == null ? void 0 : _a.closeDateTime) && new Date(zone.schedule.closeDateTime) < /* @__PURE__ */ new Date();
            const endDate = !hasEnded && ((_b = zone.schedule) == null ? void 0 : _b.closeDateTime) && formattedEndDate(zone.schedule.closeDateTime);
            return /* @__PURE__ */ jsxs6(
              Button6,
              {
                as: Link4,
                theme: "white",
                shape: "text",
                href: `/${locale}${createSectionItemHref(zone)}`,
                className: "group relative flex h-60 shrink-0 basis-2/5 items-center justify-center overflow-hidden rounded-xl sm:basis-1/4 md:basis-1/5 xl:basis-1/6 ltr:mr-4 rtl:ml-4",
                "data-testid": `section_zone_carousel_item_${zone.slug}`,
                onClick: () => {
                  var _a2;
                  trackEvent({
                    event: "clicked_on_section_item",
                    data: {
                      type: zone.__typename,
                      item_id: (_a2 = zone.sys) == null ? void 0 : _a2.id,
                      slug: zone.slug,
                      section: section.id,
                      position: i
                    }
                  });
                },
                children: [
                  !hasEnded ? /* @__PURE__ */ jsx6(
                    ContentfulMedia_default,
                    {
                      media: zone.featuredBanner,
                      fit: "thumb",
                      className: "absolute -z-10 h-full w-full object-cover opacity-40 transition group-hover:opacity-60",
                      placeholder: true
                    }
                  ) : /* @__PURE__ */ jsx6("div", { className: "absolute -z-10 h-full w-full bg-zinc-900" }),
                  /* @__PURE__ */ jsxs6("div", { className: `relative z-10 ${hasEnded ? "opacity-50 grayscale filter" : ""}`, children: [
                    (zone == null ? void 0 : zone.zoneLogo) && /* @__PURE__ */ jsx6(
                      ContentfulMedia_default,
                      {
                        className: "mx-auto max-w-24 shrink-0",
                        media: zone.zoneLogo,
                        width: 250,
                        height: 250,
                        fit: "pad"
                      }
                    ),
                    (zone == null ? void 0 : zone.sponsorLogo) && /* @__PURE__ */ jsxs6("div", { className: "space-y-2", children: [
                      /* @__PURE__ */ jsx6("p", { className: "text-text-secondary text-xs", children: t("contentful_zone:presented_by") }),
                      /* @__PURE__ */ jsx6(
                        ContentfulMedia_default,
                        {
                          className: "mx-auto max-h-6 w-auto shrink-0",
                          media: zone == null ? void 0 : zone.sponsorLogo,
                          fit: "crop"
                        }
                      )
                    ] })
                  ] }),
                  endDate && /* @__PURE__ */ jsx6("div", { className: "absolute bottom-4 left-1/2 -translate-x-1/2 text-[11px] text-yellow-500", children: t("contentful_zone:zone_ends", {
                    date: endDate
                  }) }),
                  hasEnded && /* @__PURE__ */ jsx6("span", { className: "absolute bottom-4 left-1/2 -translate-x-1/2 text-[11px] capitalize text-zinc-500", children: t("contentful_zone:ended") })
                ]
              },
              i
            );
          })
        }
      )
    }
  );
};
var ZoneCarousel_default = ZoneCarousel;

// src/components/zone/OtherZonesCarousel.tsx
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var OtherZonesCarousel = ({ where }) => {
  const { locale } = useRouter6();
  const { t } = useTranslation7("contentful_zone");
  const { data, isLoading } = useGetZones({ lang: locale, where });
  if (isLoading) {
    return /* @__PURE__ */ jsxs7("div", { className: "container space-y-8 py-12", children: [
      /* @__PURE__ */ jsx7("div", { className: "bg-body-light/50 h-6 max-w-xs rounded-xl sm:max-w-[20%]" }),
      /* @__PURE__ */ jsx7("ul", { className: "flex gap-2 overflow-x-hidden", children: [1, 2, 3, 4, 5, 6, 7, 8].map((idx) => /* @__PURE__ */ jsx7(
        "li",
        {
          className: "bg-body-light/50 h-60 shrink-0 basis-2/5 animate-pulse rounded-xl sm:basis-1/4 md:basis-1/5 xl:basis-1/6"
        },
        idx
      )) })
    ] });
  }
  if (data) {
    return /* @__PURE__ */ jsx7(
      ZoneCarousel_default,
      {
        section: {
          title: t("common:other_zones"),
          id: "other-zones",
          webLinksCollection: { items: [] },
          contentCollection: {
            items: data.items
          },
          categoriesCollection: { items: [] },
          tagsCollection: { items: [] }
        }
      }
    );
  }
  return null;
};
var OtherZonesCarousel_default = OtherZonesCarousel;

// src/components/zone/PageSkeleton.tsx
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var ZonePageSkeleton = () => {
  return /* @__PURE__ */ jsxs8("section", { className: "container space-y-10 py-6", children: [
    /* @__PURE__ */ jsx8("div", { className: "bg-body-dark/10 h-9 max-w-sm animate-pulse rounded-md" }),
    /* @__PURE__ */ jsxs8("div", { className: "flex h-48 gap-4", children: [
      /* @__PURE__ */ jsx8("div", { className: "bg-body-dark/10 w-full max-w-[100px] grow animate-pulse rounded-md sm:max-w-[140px]" }),
      /* @__PURE__ */ jsx8("div", { className: "bg-body-dark/10 w-full grow animate-pulse rounded-md" })
    ] }),
    /* @__PURE__ */ jsx8("div", { className: "flex gap-2 overflow-hidden", children: [1, 2, 3, 4].map((idx) => /* @__PURE__ */ jsx8(
      "div",
      {
        className: "bg-body-dark/10 aspect-[3/2] w-full shrink-0 basis-[75%] animate-pulse rounded-md sm:basis-[60%] md:basis-[50%] lg:basis-[40%] xl:basis-[30%]"
      },
      idx
    )) }),
    /* @__PURE__ */ jsx8("div", { className: "bg-body-dark/10 mx-auto h-28 w-full max-w-[90%] grow animate-pulse rounded-xl" }),
    /* @__PURE__ */ jsx8("div", { className: "flex gap-2 overflow-hidden", children: "1".repeat(20).split("").map((idx, i) => /* @__PURE__ */ jsx8(
      "div",
      {
        className: "bg-body-dark/10 h-24 w-24 shrink-0 animate-pulse rounded-full"
      },
      idx + i
    )) }),
    /* @__PURE__ */ jsx8("div", { className: "bg-body-dark/10 mx-auto h-80 w-full animate-pulse rounded-xl" }),
    /* @__PURE__ */ jsx8("div", { className: "bg-body-dark/10 mx-auto h-80 w-full animate-pulse rounded-xl" })
  ] });
};
var PageSkeleton_default = ZonePageSkeleton;

// src/components/zone/ZoneGrid.tsx
import { Button as Button7, Typography as Typography4 } from "@wbk/ui";
import { Link as Link5, useRouter as useRouter7, useTranslation as useTranslation8 } from "@wbk/config";
import { useAnalytics as useAnalytics4 } from "@wbk/analytics";
import { jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var ZoneGrid = ({ section }) => {
  const { locale } = useRouter7();
  const { t } = useTranslation8("contentful_zone");
  const zones = section.contentCollection.items;
  const { trackEvent } = useAnalytics4();
  if (!zones.length) return null;
  return /* @__PURE__ */ jsxs9(
    DecoratedSection_default,
    {
      section,
      "data-testid": `section_zone_grid_${section.id}`,
      className: "container",
      children: [
        section.title && /* @__PURE__ */ jsxs9("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx9(Typography4, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx9(Typography4, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx9("ul", { className: "grid grid-cols-2 gap-3 md:grid-cols-3", children: zones.map((zone, i) => {
          if (!zone) return null;
          return /* @__PURE__ */ jsxs9("li", { className: "relative aspect-[3/2.2]", children: [
            zone.newZone && /* @__PURE__ */ jsx9("span", { className: "bg-success text-success-contrast absolute left-1/2 top-0 z-10 -translate-x-1/2 -translate-y-1/2 rounded-full px-2 py-px text-xs uppercase", children: t("contentful_zone:new") }),
            /* @__PURE__ */ jsxs9(
              Button7,
              {
                as: Link5,
                theme: "white",
                shape: "text",
                className: "data-[new=true]:border-success group relative h-full w-full rounded-lg border-2 border-transparent p-0",
                href: `/${locale}/${createSectionItemHref(zone)}`,
                "data-new": zone.newZone,
                "data-testid": `section_zone_grid_item_${zone.slug}`,
                onClick: () => {
                  var _a;
                  trackEvent({
                    event: "clicked_on_section_item",
                    data: {
                      type: zone.__typename,
                      item_id: (_a = zone.sys) == null ? void 0 : _a.id,
                      slug: zone.slug,
                      section: section.id,
                      position: i
                    }
                  });
                },
                children: [
                  zone.featuredBanner && /* @__PURE__ */ jsx9(
                    ContentfulMedia_default,
                    {
                      media: zone.featuredBanner,
                      className: "absolute -z-10 h-full w-full object-cover",
                      fit: "crop",
                      placeholder: true
                    }
                  ),
                  /* @__PURE__ */ jsx9("div", { className: "bg-body/70 group-hover:bg-body/60 flex h-full w-full items-center justify-center p-4 transition", children: (zone == null ? void 0 : zone.zoneLogo) && /* @__PURE__ */ jsxs9("div", { className: "w-full space-y-2", children: [
                    /* @__PURE__ */ jsx9(
                      ContentfulMedia_default,
                      {
                        media: zone.zoneLogo,
                        className: "mx-auto max-w-[45%]",
                        fit: "pad",
                        width: 140,
                        height: 140
                      }
                    ),
                    zone.sponsorLogo && /* @__PURE__ */ jsx9(
                      ContentfulMedia_default,
                      {
                        className: "mx-auto max-w-[25%]",
                        media: zone.sponsorLogo,
                        fit: "crop"
                      }
                    )
                  ] }) })
                ]
              }
            )
          ] }, i);
        }) })
      ]
    }
  );
};
var ZoneGrid_default = ZoneGrid;

// src/components/zone/ZoneCardsCarousel.tsx
import { Button as Button8, Carousel as Carousel4, Divider as Divider2, Typography as Typography5 } from "@wbk/ui";
import { Link as Link6, useRouter as useRouter8, useTranslation as useTranslation9 } from "@wbk/config";
import { useAnalytics as useAnalytics5 } from "@wbk/analytics";
import { Fragment as Fragment5 } from "react/jsx-runtime";
import { Fragment as Fragment6, jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var ZoneCardsCarousel = ({ section }) => {
  const { locale } = useRouter8();
  const { t } = useTranslation9("contentful_zone");
  const zones = section.contentCollection.items;
  const { trackEvent } = useAnalytics5();
  if (!zones.length) return null;
  return /* @__PURE__ */ jsx10(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_cards_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx10(
        Carousel4,
        {
          options: { dragFree: true },
          className: "p-1",
          title: /* @__PURE__ */ jsxs10(Fragment6, { children: [
            section.title && /* @__PURE__ */ jsx10(Typography5, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx10(Typography5, { color: "text-secondary", className: "mt-1", children: section.subtitle })
          ] }),
          arrows: "top",
          children: zones.map((zone, i) => {
            if (!zone) return null;
            return /* @__PURE__ */ jsx10(Fragment5, { children: /* @__PURE__ */ jsxs10("div", { className: "relative shrink-0 basis-56 ltr:mr-4 rtl:ml-4", children: [
              zone.newZone && /* @__PURE__ */ jsx10("span", { className: "bg-success text-success-contrast absolute top-0 z-10 m-3 rounded-full px-2 py-px text-sm uppercase ltr:left-0 rtl:right-0", children: t("contentful_zone:new") }),
              /* @__PURE__ */ jsxs10(
                Button8,
                {
                  as: Link6,
                  theme: "white",
                  shape: "text",
                  className: "data-[new=true]:border-success border-paper group relative h-full w-full flex-col rounded-lg border-2 p-0",
                  href: `/${locale}${createSectionItemHref(zone)}`,
                  "data-new": zone.newZone,
                  "data-testid": `section_zone_grid_item_${zone.slug}`,
                  onClick: () => {
                    var _a;
                    trackEvent({
                      event: "clicked_on_section_item",
                      data: {
                        type: zone.__typename,
                        item_id: (_a = zone.sys) == null ? void 0 : _a.id,
                        slug: zone.slug,
                        section: section.id,
                        position: i
                      }
                    });
                  },
                  children: [
                    /* @__PURE__ */ jsx10(
                      ContentfulMedia_default,
                      {
                        media: zone.featuredBanner,
                        className: "aspect-[3/2] object-cover",
                        fit: "crop",
                        placeholder: true
                      }
                    ),
                    /* @__PURE__ */ jsxs10("div", { className: "relative z-20 h-full w-full p-2", children: [
                      (zone == null ? void 0 : zone.zoneLogo) && /* @__PURE__ */ jsx10("div", { className: "bg-body-light mx-auto -mt-12 flex h-[72px] w-[72px] items-center justify-center rounded-full", children: /* @__PURE__ */ jsx10(
                        ContentfulMedia_default,
                        {
                          media: zone.zoneLogo,
                          className: "h-12 w-12 shrink-0 object-cover",
                          fit: "pad",
                          width: 140,
                          height: 140
                        }
                      ) }),
                      /* @__PURE__ */ jsxs10("div", { className: "w-full justify-center space-y-3 text-center", children: [
                        /* @__PURE__ */ jsx10(Typography5, { variant: "label-M", children: /* @__PURE__ */ jsx10("strong", { children: zone.title }) }),
                        zone.sponsorLogo && /* @__PURE__ */ jsxs10(Fragment6, { children: [
                          /* @__PURE__ */ jsx10(Divider2, { className: "w-full" }),
                          /* @__PURE__ */ jsxs10("div", { className: "flex w-full items-center justify-center gap-2", children: [
                            /* @__PURE__ */ jsx10(Typography5, { variant: "body-XS", color: "text-secondary", children: t("contentful_zone:sponsor") }),
                            /* @__PURE__ */ jsx10(
                              ContentfulMedia_default,
                              {
                                className: "max-h-5 w-auto shrink-0",
                                media: zone.sponsorLogo,
                                fit: "pad"
                              }
                            )
                          ] })
                        ] })
                      ] })
                    ] })
                  ]
                }
              )
            ] }, i) }, i);
          })
        }
      )
    }
  );
};
var ZoneCardsCarousel_default = ZoneCardsCarousel;

export {
  Breadcrumb_default,
  Info_default,
  Hero_default,
  HeroRS_default,
  ZoneCarousel_default,
  OtherZonesCarousel_default,
  PageSkeleton_default,
  ZoneGrid_default,
  ZoneCardsCarousel_default
};
//# sourceMappingURL=chunk-JAMQJQDP.mjs.map